export function initialize(/* application */
) {
  // This exists just to prevent ember-could-get-used-to-this'
  // function-manager from loading
  // see: https://github.com/tracked-tools/ember-could-get-used-to-this/blob/master/addon/initializers/usable-function-manager.js
}
export default {
  initialize
};